import { render, staticRenderFns } from "./customer-statement.vue?vue&type=template&id=41aa6c4a&scoped=true"
import script from "./customer-statement.vue?vue&type=script&lang=js"
export * from "./customer-statement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa6c4a",
  null
  
)

export default component.exports